import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { getUserDeviceByPublicId, updateUserDevice } from "../../api/Agreement";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import DeviceForm from "../../components/userDevice/DeviceForm";
import Breadcrumbs from "../../components/Breadcrumbs";

const EditUserDevicePage = () => {
  const { userDevicePublicId } = useParams();
  const { getAccessToken } = useAuth();
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);
  const [loadingUserDevice, setLoadingUserDevice] = useState(true);
  const [hasChanges, setHasChanges] = useState(false);
  const [confirmState, setConfirmState] = useState({ isOpen: false, id: "" });

  useEffect(() => {
    if (userDevicePublicId) {
      handleGetUserDevice();
    }
  }, [userDevicePublicId]);

  const handleGetUserDevice = async () => {
    try {
      const accessToken = await getAccessToken();
      const device = await getUserDeviceByPublicId(userDevicePublicId, accessToken);

      setDevice(device);
    } catch (error) {
      console.error("Failed to fetch user device:", error);
    }
    setLoadingUserDevice(false);
  };

  const handleBackClick = () => {
    if (hasChanges) {
      setConfirmState({
        isOpen: true,
        title: "Discard changes?",
        confirm: () => navigate(-1),
      });
    } else {
      navigate(-1);
    }
  };

  const handleUpdateUserDevice = async () => {
    try {
      const accessToken = await getAccessToken();

      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const userDeviceData = {
        userDevicePublicId: device.userDevicePublicId,
        productUrl: device.productUrl,
        displayName: device.displayName,
      };

      console.log("Sending updated user device:", userDeviceData); // Debug: Check what is being sent

      await updateUserDevice( userDeviceData, accessToken);

      toast.success("User device updated successfully", {
        iconTheme: { primary: "#4CAF50", secondary: "#DFF2BF" },
      });
      window.dispatchEvent(new Event("userDeviceUpdated"));

      setHasChanges(false);
    } catch (error) {
      toast.error("Failed to update user device");
    }
    navigate(-1);
  };

  console.log("DEVICE:", device);

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute w-full pointer-events-none">
            <LoadingTablePage title={"Edit user device"} loading={loadingUserDevice} />
          </div>
          <div className={`${loadingUserDevice ? "loading" : ""} page-content`}>
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Edit user device: {device?.displayName || "Unknown"}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick={handleUpdateUserDevice}
                >
                  Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <DeviceForm
                device={device}
                setDevice={setDevice}
                setHasChanges={setHasChanges}
                disabled={false}
              />
            </div>
          </div>
        </main>
      </div>
      <ConfirmationModal
        isOpen={confirmState.isOpen}
        title={confirmState.title || "Discard changes?"}
        onClose={() => setConfirmState({ isOpen: false })}
        onConfirm={() => {
          setConfirmState({ isOpen: false });
          confirmState.confirm();
        }}
      />
    </>
  );
};

export default EditUserDevicePage;
